import gql from 'graphql-tag'
import { resourceFragment, resourceTypeFragment } from '@/graphql/resource/resourceFragments'

export const UPSERTRESOURCE = gql`
    mutation upsertResource(
        $id: ID
        $name: String!
        $description: String
        $typeID: ID
        $disconnectType: Boolean
        $tracked: Boolean
        $applyTo: ApplyToModels
    ){
        upsertResource(
            input: {
                id: $id
                name: $name
                description: $description
                type: {
                    connect: $typeID
                    disconnect: $disconnectType
                }
                tracked: $tracked
                applyTo: $applyTo
            }
        ){
            ...resourceFragment
            type {
                ...resourceTypeFragment
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
`
export const UPSERTRESOURCETYPE = gql`
    mutation upsertResourceType(
        $id: ID
        $name: String!
    ){
        upsertResourceType(
            id: $id
            name: $name
        ){
            ...resourceTypeFragment
        }
    }
    ${resourceTypeFragment}
`
export const RESTORERESOURCE = gql`
    mutation restoreResource(
        $id: ID!
    ){
        restoreResource(
            id: $id
        ){
            ...resourceFragment
        }
    }
    ${resourceFragment}
`

export const RESTORERESOURCETYPE = gql`
    mutation restoreResourceType(
        $id: ID!
    ){
        restoreResourceType(
            id: $id
        ){
            ...resourceTypeFragment
        }
    }
    ${resourceTypeFragment}
`

export const DELETERESOURCE = gql`
    mutation deleteResource(
        $id: ID!
    ){
        deleteResource(
            id: $id
        ){
            ...resourceFragment
        }
    }
    ${resourceFragment}
`
export const DELETERESOURCETYPE = gql`
    mutation deleteResourceType(
        $id: ID!
    ){
        deleteResourceType(
            id: $id
        ){
            ...resourceTypeFragment
        }
    }
    ${resourceTypeFragment}
`